<lcs-loading-overlay [show]="callState | lcsCallState : 'loading'">
   <div mat-dialog-title class="dialog-header">
      <h3 class="dialog-title">Add Location</h3>
      <button type="button" mat-icon-button tabindex="-1" (click)="onCloseClick()"><mat-icon>close</mat-icon></button>
   </div>
   <form [formGroup]="form" (ngSubmit)="onCreate()">
      <mat-dialog-content>
         <h5 class="form-section-heading">Details</h5>
         <div class="flex-container">
            <mat-form-field class="flex-half">
               <mat-label>Name</mat-label>
               <input matInput autocomplete="off" type="text" formControlName="name" id="name" #name />
               @if (form.get('name')?.hasError('maxlength')) {
               <mat-error>Name must be less than 255 characters</mat-error>
               } @if (form.get('name')?.hasError('pattern') || form.get('name')?.hasError('noContent')) {
               <mat-error> Name must contain characters. </mat-error>
               }
            </mat-form-field>

            <mat-form-field class="flex-half">
               <mat-label>Comment</mat-label>
               <input matInput autocomplete="off" type="text" formControlName="comment" id="comment" />
               @if (form.get('comment')?.hasError('maxlength')) {
               <mat-error> Comment field limited to 50 characters. </mat-error>
               }
            </mat-form-field>
         </div>

         <h5 class="form-section-heading">Address</h5>

         <div class="add-location-row add-location-row--house">
            <mat-form-field class="add-location-field--house">
               <mat-label>House Number</mat-label>
               <input matInput autocomplete="off" type="text" formControlName="houseNumber" id="houseNumber" required />
               @if (form.get('houseNumber')?.hasError('required')) {
               <mat-error> House Number is Required. </mat-error>
               } @if (form.get('houseNumber')?.hasError('maxlength')) {
               <mat-error> House Number limited to 255 characters. </mat-error>
               } @if (form.get('houseNumber')?.hasError('pattern')) {
               <mat-error> House Number must only contain numbers. </mat-error>
               }
            </mat-form-field>
            <mat-form-field class="add-location-field--dir">
               <mat-label>Street Direction Prefix</mat-label>
               <input
                  matInput
                  autocomplete="off"
                  type="text"
                  formControlName="directionalPrefix"
                  id="directionalPrefix"
               />
               @if (form.get('directionalPrefix')?.hasError('maxlength')) {
               <mat-error> Street Direction Prefix limited to 255 characters. </mat-error>
               }
            </mat-form-field>
         </div>

         <div class="add-location-row add-location-row--street">
            <mat-form-field class="add-location-field--street">
               <mat-label>Street Name</mat-label>
               <input matInput autocomplete="off" type="text" formControlName="streetName" id="streetName" required />
               @if (form.get('streetName')?.hasError('required')) {
               <mat-error> Street Name is Required. </mat-error>
               } @if (form.get('streetName')?.hasError('maxlength')) {
               <mat-error> Street Name limited to 255 characters. </mat-error>
               }
            </mat-form-field>
         </div>

         <div class="add-location-row add-location-row--suffix">
            <mat-form-field class="add-location-field--suffix">
               <mat-label>Street Name Suffix</mat-label>
               <input
                  matInput
                  autocomplete="off"
                  type="text"
                  formControlName="streetNameSuffix"
                  id="streetNameSuffix"
               />
               @if (form.get('streetNameSuffix')?.hasError('maxlength')) {
               <mat-error> Street Name Suffix limited to 255 characters </mat-error>
               }
            </mat-form-field>
            <mat-form-field class="add-location-field--dir">
               <mat-label>Street Direction Suffix</mat-label>
               <input
                  matInput
                  autocomplete="off"
                  type="text"
                  formControlName="directionalPostfix"
                  id="directionalPostfix"
               />
               @if (form.get('directionalPostfix')?.hasError('pattern')) {
               <mat-error> Invalid Street Direction Suffix </mat-error>
               }
            </mat-form-field>
         </div>

         <div class="add-location-row add-location-row--city">
            <mat-form-field class="add-location-field--city">
               <mat-label>City</mat-label>
               <input matInput autocomplete="off" type="text" formControlName="city" id="city" required />
               @if (form.get('city')?.hasError('required')) {
               <mat-error> City is Required. </mat-error>
               } @if (form.get('city')?.hasError('maxlength')) {
               <mat-error> City limited to 255 characters. </mat-error>
               }
            </mat-form-field>
         </div>

         <div class="add-location-row add-location-row--state">
            <mat-form-field class="add-location-field--state">
               <mat-label>State</mat-label>
               <input
                  autocomplete="off"
                  type="text"
                  formControlName="state"
                  id="state"
                  lcsStaticSelect
                  [lcsSingleSelect]="stateSelect"
                  [lcsStaticSelectValue]="form.get('state')?.value"
                  (search)="stateSearch($event)"
                  (reset)="stateSearchReset()"
                  (stateChanged)="handleStateChange($event)"
                  required
               />
               <lcs-static-select #stateSelect [displayWith]="stateDisplayWith" [autoActiveFirstOption]="false">
                  @for (states of states; track states) {
                  <lcs-option [value]="states.abbreviation"> {{ states.name }} - {{ states.abbreviation }} </lcs-option>
                  }
               </lcs-static-select>
               @if (form.get('state')?.hasError('required')) {
               <mat-error> State is Required. </mat-error>
               } @if (!form.get('state')?.hasError('required') && form.get('state')?.hasError('whitespace')) {
               <mat-error>State cannot have whitespace</mat-error>
               }
            </mat-form-field>
            <mat-form-field class="add-location-field--postal">
               <mat-label>Postal Code</mat-label>
               <input matInput autocomplete="off" type="text" formControlName="postalCode" id="postalCode" required />
               @if (form.get('postalCode')?.hasError('required')) {
               <mat-error> Postal Code is Required. </mat-error>
               } @if (!form.get('postalCode')?.hasError('required') && form.get('postalCode')?.hasError('whitespace')) {
               <mat-error> Invalid Postal Code. </mat-error>
               }
            </mat-form-field>
         </div>

         <div class="add-location-row add-location-row--intl">
            <mat-form-field class="add-location-field--half">
               <mat-label>Country</mat-label>
               <input
                  autocomplete="off"
                  type="text"
                  formControlName="country"
                  id="country"
                  lcsStaticSelect
                  [lcsSingleSelect]="countrySelect"
                  [lcsStaticSelectValue]="form.get('country')?.value"
                  (search)="countrySearch($event)"
                  (reset)="countrySearchReset()"
               />
               <lcs-static-select #countrySelect [displayWith]="countryDisplayWith">
                  @for (countries of countries; track countries) {
                  <lcs-option [value]="countries">
                     {{ countries }}
                  </lcs-option>
                  }
               </lcs-static-select>
            </mat-form-field>
            <mat-form-field class="add-location-field--half">
               <mat-label>Time Zone</mat-label>
               <input
                  [lcsSingleSelect]="timeZoneSelect"
                  ndtTimeZoneSelect
                  autocomplete="off"
                  type="text"
                  formControlName="timeZone"
                  id="time-zone"
                  required
               />
               <ndt-time-zone-select #timeZoneSelect></ndt-time-zone-select>
               @if (form.get('timeZone')?.hasError('required')) {
               <mat-error> Time Zone Field is Required. </mat-error>
               }
            </mat-form-field>
         </div>
      </mat-dialog-content>
      <mat-dialog-actions>
         <button type="button" title="submitAndAddAnother" (click)="onCreateAndAddAnother()" mat-stroked-button
            >Save and Add Another</button
         >
         <button type="submit" title="Create" mat-raised-button color="primary">Save</button>
      </mat-dialog-actions>
   </form>
</lcs-loading-overlay>
